document.addEventListener("DOMContentLoaded", function () {

  const modalId = "moq-quantity";
  const openLinks = document.querySelectorAll('a[href="#' + modalId + '"]');
  const moqEntries = window.moqEntries || [];

  // === 构建 moqData ===
  const moqData = {};
  moqEntries.forEach(entry => {
    if (!moqData[entry.type]) moqData[entry.type] = {};
    moqData[entry.type][entry.material] = {
      MOQ: Number(entry.moq) || 0,
      OTS_MOQ: Number(entry.ots_moq) || 0,
      Link: entry.link || "",
      Title: entry.title || "",
      OTS_Link: entry.ots_link || "",
      OTS_Title: entry.ots_title || ""
    };
  });

  // === 指定排序顺序 ===
  const preferredOrder = [
    "Mailers - fully customised",
    "Mailers - Partly customised",
    "Bubble Mailers",
    "Envelopes",
    "Poly Garment Bags",
    "Carry Bags",
    "Hygiene Liners"
  ];
  const productTypes = Object.keys(moqData);
  const sortedTypes = productTypes.sort((a, b) => {
    const indexA = preferredOrder.indexOf(a);
    const indexB = preferredOrder.indexOf(b);
    return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
  });

  // Helper: populate select while keeping placeholder
  function populateSelect(selectEl, options, placeholder) {
    if (!selectEl) return;
    selectEl.innerHTML = ""; // 清空
    if (placeholder) {
      const placeholderOption = document.createElement("option");
      placeholderOption.value = "";
      placeholderOption.textContent = placeholder;
      selectEl.appendChild(placeholderOption);
    }
    options.forEach(opt => {
      if (!Array.from(selectEl.options).some(o => o.value === opt)) {
        const optionEl = document.createElement("option");
        optionEl.value = opt;
        optionEl.textContent = opt;
        selectEl.appendChild(optionEl);
      }
    });
  }

  // 初始化并绑定 modal（只绑定一次）
  function initModal(modal) {
    if (!modal) return;
    if (modal.dataset.initialized === "1") return;

    const productTypeSelect = modal.querySelector(".product_type_select");
    const materialSelect = modal.querySelector(".material_select");
    const quantityInput = modal.querySelector(".quantity_input");
    const resultDiv = modal.querySelector(".moqResult");
    const linkDiv = modal.querySelector(".productLinkContainer");
    const result2Div = modal.querySelector(".moqResult2");
    const closeBtn = modal.querySelector(".moq-calc-close");
    const overlay = modal.querySelector(".moq-calculator-quantity-overlay");

    // Reset 所有状态
    function resetAll() {
      populateSelect(productTypeSelect, sortedTypes, "-- Select Product Type --");
      populateSelect(materialSelect, [], "-- Select Material --");
      if (quantityInput) quantityInput.value = "";
      if (resultDiv) resultDiv.textContent = "";
      if (linkDiv) linkDiv.innerHTML = "";
      if (result2Div) result2Div.textContent = "";
    }
    // 保存以便外部打开时调用
    modal._moqReset = resetAll;

    // 页面第一次初始化
    resetAll();

    // 关闭弹窗逻辑
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        modal.style.display = "none";
        resetAll();
      });
    }
    if (overlay) {
      overlay.addEventListener("click", () => {
        modal.style.display = "none";
        resetAll();
      });
    }

    // Product Type -> Material
    if (productTypeSelect) {
      productTypeSelect.addEventListener("change", () => {
        if (resultDiv) resultDiv.textContent = "";
        if (linkDiv) linkDiv.innerHTML = "";
        if (result2Div) result2Div.textContent = "";
        if (quantityInput) quantityInput.value = "";

        if (!productTypeSelect.value) {
          populateSelect(materialSelect, [], "-- Select Material --");
          return;
        }
        const mats = Object.keys(moqData[productTypeSelect.value] || {});
        populateSelect(materialSelect, mats, "-- Select Material --");
      });
    }

    // Quantity 输入：只允许整数、千分位显示、恢复光标，并使用剥离后的整数判断 MOQ
    if (quantityInput) {
      quantityInput.addEventListener("input", (e) => {
        const val = quantityInput.value || "";
        const selStart = quantityInput.selectionStart || 0;
        const digitsBeforeCursor = (val.slice(0, selStart).match(/\d/g) || []).length;

        // 仅保留数字字符
        const digits = val.replace(/[^\d]/g, "");

        // 格式化显示（千分位）
        const formatted = digits ? digits.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";
        quantityInput.value = formatted;

        // 恢复光标到原先的数字索引位置
        if (digitsBeforeCursor === 0) {
          quantityInput.setSelectionRange(0, 0);
        } else if (formatted) {
          let seen = 0;
          let newPos = formatted.length;
          for (let i = 0; i < formatted.length; i++) {
            if (/\d/.test(formatted[i])) seen++;
            if (seen === digitsBeforeCursor) { newPos = i + 1; break; }
          }
          quantityInput.setSelectionRange(newPos, newPos);
        }

        // 使用剥离后的整数进行逻辑判断
        const entry = moqData?.[productTypeSelect?.value]?.[materialSelect?.value];
        const qty = digits ? parseInt(digits, 10) : NaN;
        if (!entry || isNaN(qty) || qty <= 0) {
          if (resultDiv) resultDiv.textContent = "";
          if (linkDiv) linkDiv.innerHTML = "";
          if (result2Div) result2Div.textContent = "";
          return;
        }

        if (qty >= entry.MOQ) {
          if (resultDiv) resultDiv.innerHTML = `
            Great news! You are able to custom brand this selection, as
            the MOQ is: <strong>${entry.MOQ.toLocaleString()}</strong> units.
          `;
          if (linkDiv) linkDiv.innerHTML = `<a href="${entry.Link}" target="_blank" class="button button--primary">Order ${entry.Title}</a>`;
          if (result2Div) result2Div.innerHTML = `
            Not ready to customise yet? We also carry 
            <a href="${entry.OTS_Link}" target="_blank" class="button button--link-style" style="text-transform:none;">this packaging in stock</a>
          `;
        } else {
          if (resultDiv) resultDiv.innerHTML = `
            This selection is available from our in-stock range, starting at 
            <strong>${entry.OTS_MOQ.toLocaleString()}</strong> units.
          `;
          if (linkDiv) linkDiv.innerHTML = `<a href="${entry.OTS_Link}" target="_blank" class="button button--primary">Shop ${entry.OTS_Title}</a>`;
          if (result2Div) result2Div.innerHTML = `
            If you would like to custom brand this type of packaging, the MOQ is: 
            <strong>${entry.MOQ.toLocaleString()}</strong> units.
          `;
        }
      });
    }

    // 标记已初始化，避免重复绑定
    modal.dataset.initialized = "1";
  }

  // 为页面上指向 modal 的链接绑定点击，点击时再查找并初始化 modal
  openLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const modal = document.getElementById(modalId);
      if (!modal) {
        console.warn("MOQ modal not found in DOM:", modalId);
        return;
      }
      initModal(modal);
      // 每次打开都重置状态
      if (modal._moqReset) modal._moqReset();
      modal.style.display = "flex";
    });
  });

});